import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styles from "../../gmanewstyle.module.css";
import logoimage from "../assets/Group -2.png";
import { format } from "date-fns";
import PortalSidebar from "../PortalSidebar/PortalSidebar";

export default function AODDetailPage() {
  const { id, buildingId } = useParams();
  const navigate = useNavigate();
  const buildingname = localStorage.getItem("buildingName");
  const [aod, setAod] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  // Default sidebar state based on device width
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);

useEffect(() => {
  const handleResize = () => {
    const desktop = window.innerWidth >= 1024;
    setIsDesktop(desktop);

    // Only force closed when moving to smaller screens.
    // On desktop, keep whatever state the user last chose.
    if (!desktop) {
      setSidebarOpen(false);
    }
  };

  handleResize();
  window.addEventListener("resize", handleResize);

  return () => window.removeEventListener("resize", handleResize);
}, []);
  useEffect(() => {
  function handleClick(e) {
    // On desktop/laptop, only the burger should control the sidebar
    if (isDesktop) return;

    const sidebar = document.getElementsByClassName(styles.sidebar)[0];
    const hamburger = document.getElementsByClassName(styles.menuBtn)[0];

    if (!sidebar || !hamburger) return;

    const clickedInsideSidebar = sidebar.contains(e.target);
    const clickedHamburger = hamburger.contains(e.target);

    if (sidebarOpen && !clickedInsideSidebar && !clickedHamburger) {
      setSidebarOpen(false);
    }
  }

  document.addEventListener("click", handleClick);
  return () => document.removeEventListener("click", handleClick);
}, [sidebarOpen, isDesktop]);

  // format dates, fallback to '-'
  const fmtDate = (d) => {
    if (!d) return "-";
    try {
      return format(new Date(d), "dd MMM yyyy");
    } catch {
      return "-";
    }
  };

  // pick the OData formatted value first, fallback raw, otherwise '-'
  const display = (key) => {
    if (!aod) return "-";
    const fmt = aod[`${key}@OData.Community.Display.V1.FormattedValue`];
    const raw = aod[key];
    if (fmt != null && fmt !== "") return fmt;
    if (raw != null && raw !== "") return raw;
    return "-";
  };

  const [userAccess, setUserAccess] = useState([]);
  const [loadingAccess, setLoadingAccess] = useState(true);

  const [displayName, setDisplayName] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  // pull user access for top-right dropdown
  useEffect(() => {
    const fetchUserAccess = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/");
        return;
      }

      try {
        const decoded = JSON.parse(atob(token.split(".")[1]));
        const { email, contact_id, firstname, lastname, name } = decoded || {};

        // Set display name safely
        const fullName =
          firstname && lastname
            ? `${firstname} ${lastname}`
            : name
              ? name
              : email || "User";

        setDisplayName(fullName);

        if (!email) {
          setLoadingAccess(false);
          return;
        }

        const resp = await fetch(
          "https://portal.gmacc.co.za/api/contact/determine-access/",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ email, contact_id }),
          },
        );

        const data = await resp.json();
        if (resp.ok) {
          setUserAccess(data.access || []);
        }
      } catch (err) {
        console.error("Failed to fetch access:", err);
      } finally {
        setLoadingAccess(false);
      }
    };

    fetchUserAccess();
  }, [navigate]);


  const handleOwnerPortalClick = () => navigate("/owner-portal");
  const handleTrusteePortalClick = () => navigate("/trustee-portal");
  const handleContractorPortalClick = () => {
    navigate("/contractor-portal");
  };

  useEffect(() => {
    document.title = `AOD DETAILS - ${display("cj_aodnumber")}`;
    const token = localStorage.getItem("token");
    if (!token) return navigate("/");

    (async () => {
      try {
        const res = await fetch(`https://portal.gmacc.co.za/api/aods/${id}/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error();
        setAod(await res.json());
      } catch {
        setError("Could not load AOD details.");
      } finally {
        setLoading(false);
      }
    })();
  }, [id, navigate]);

  if (loading) {
    return (
      <div className={styles.page}>
        <div className={styles.shell}>
          <main className={styles.contentArea}>
            <div className={styles.panel}>
              <div className={styles.loadingContainer}>
                <div className={styles.loadingImage}></div>
                <p className={styles.loadingText}>Loading AOD...</p>
              </div>
            </div>
          </main>
        </div>
      </div>
    );
  }
  if (error) return <p className={styles.errorText}>{error}</p>;

  // parse numeric values for receipts comparison
  const requiredRaw =
    parseFloat(aod.cj_totalrequiredreceiptssincesignature) || 0;
  const receivedRaw = parseFloat(aod.cj_totalreceiptssincedateofsignature) || 0;
  const receiptsOK = receivedRaw >= requiredRaw;

  // Fields definitions
  const summaryFields = [
    ["Agreement Number", "cj_aodnumber"],
    ["Stage", "cj_progressstage"],
    ["Start Date", "cj_aodstartdate"],
    ["End Date", "cj_aodenddate"],
    ["Amount", "cj_amountavailableforagreement"],
  ];

  const generalFields = [
    ["AOD Number", "cj_aodnumber"],
    ["Debtor Name", "cj_fullname"],
    ["Account", "_cj_linkedaccount_value"],
    ["Building", "_cj_linkedbuilding_value"],
    // Approval Link will be conditionally rendered below
  ];

  const terms = [
    ["Agreement Term", "cj_paymentterminmonths"],
    ["Current Term", "cj_currentagreementterm"],
    ["Signature Date", "cj_dateofsignature"],
    ["Balance at Application", "cj_balanceondateofapplication"],
    ["Monthly Arrear Payment", "cj_monthlyarrearpayment2"],
    ["Monthly Current Payment", "cj_monthlycurrentpayment"],
    ["Total Monthly Payment Required", "cj_minimummonthlypaymentrequired"],
  ];

  const receipts = [
    ["Required Since Signature", "cj_totalrequiredreceiptssincesignature"],
    ["Received Since Signature", "cj_totalreceiptssincedateofsignature"],
    ["Difference", "cj_differance"],
    ["Most Recent Payment", "cj_mostrecentpaymentamount"],
    ["Date of Most Recent Payment", "cj_dateofmostrecentpayment"],
  ];

  return (
    <div className={styles.page}>
      {/* NAVBAR */}
      <header className={styles.topbar}>
        <div className={styles.topbarLeft}>
          <img src={logoimage} alt="GMA Logo" className={styles.topLogo} />

          {/* HAMBURGER: opens/closes sidebar */}
          <button
            type="button"
            className={styles.menuBtn}
            onClick={() => setSidebarOpen((v) => !v)}
          >
            ☰
          </button>

          <h1 className={styles.topTitle}>
            {buildingname} - {display("cj_aodnumber")}
          </h1>
        </div>

        {/* USER CHIP: opens dropdown */}
        <div
          className={styles.userChip}
          onClick={() => {
            navigate("/user-profile");
          }}
          style={{ cursor: "pointer" }}
        >
          <span className={styles.statusDot}></span>
          <span className={styles.userName}>{displayName} ▾</span>
        </div>
      </header>

      {/* CONTENT */}
      <div className={styles.shell}>
<PortalSidebar
  activePortal="trustee"
  activeTab="buildings"
  userAccess={userAccess}
  loadingAccess={loadingAccess}
  sidebarOpen={sidebarOpen}
  ticketRole="trustee"
/>
        <main className={styles.contentArea}>
          <div className={styles.panel}>
            {/* SUMMARY TABLE */}
            <div className={styles.paymentHeaderCard}>
              {/* BACK BUTTON */}
              <button
                className={styles.paymentBackBtn}
                onClick={() => navigate(-1)}
              >
                Back
              </button>

              {/* TITLE */}
              <h1 className={styles.paymentHeaderTitle}>AOD DETAILS</h1>

              {/* DIVIDER */}
              <div className={styles.paymentHeaderDivider} />

              {/* LABEL ROW — AUTO GRID */}
              <div
                className={styles.paymentHeaderGridAuto}
                style={{ "--col-count": summaryFields.length }}
              >
                {summaryFields.map(([label]) => (
                  <div key={label} className={styles.paymentHeaderLabelItem}>
                    {label}:
                  </div>
                ))}
              </div>

              {/* VALUE PILL */}
              <div className={styles.paymentHeaderValuePill}>
                <div
                  className={styles.paymentHeaderGridAuto}
                  style={{ "--col-count": summaryFields.length }}
                >
                  {summaryFields.map(([_, key]) => (
                    <div key={key} className={styles.paymentHeaderValueItem}>
                      {key.toLowerCase().includes("date")
                        ? fmtDate(aod[key])
                        : display(key)}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* LOWER CARDS GRID */}
            <div className={styles.paymentCardGrid}>
              {/* General */}
              <div className={styles.paymentCardDark}>
                <h2 className={styles.cardSectionTitle}>General</h2>

                {generalFields.map(([label, key]) => (
                  <div key={key} className={styles.inputGroup}>
                    <h3 className={styles.inputLabel}>{label}:</h3>

                    {/* Account & Building are clickable */}
                    {[
                      "_cj_linkedaccount_value",
                      "_cj_linkedbuilding_value",
                    ].includes(key) && display(key) !== "-" ? (
                      <span
                        className={`${styles.inputField} ${styles.relatedLinkDark}`}
                        onClick={() => {
                          const path =
                            key === "_cj_linkedaccount_value"
                              ? `/levyaccount/${aod[key]}/${buildingId}`
                              : `/building-info/${aod[key]}`;
                          navigate(path);
                        }}
                      >
                        {display(key)}
                      </span>
                    ) : (
                      <input
                        readOnly
                        value={display(key)}
                        className={styles.inputField}
                      />
                    )}
                  </div>
                ))}

                {/* Approval Link */}
                {aod._cj_approvallink_value && (
                  <div className={styles.inputGroup}>
                    <h3 className={styles.inputLabel}>Approval Link:</h3>

                    <span
                      className={`${styles.inputField} ${styles.relatedLinkDark}`}
                      onClick={() =>
                        navigate(
                          `/building-approvals/${aod._cj_approvallink_value}`,
                        )
                      }
                    >
                      {display("_cj_approvallink_value")}
                    </span>
                  </div>
                )}

                {/* Download PDF */}
                {aod.cj_aodlink && (
                  <div
                    className={styles.inputGroup}
                    style={{ marginTop: 16, textAlign: "left" }}
                  >
                    <h3 className={styles.inputLabel}>AOD PDF:</h3>
                    <a
                      href={aod.cj_aodlink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`${styles.inputField} ${styles.relatedLinkDark}`}
                    >
                      Download AOD PDF
                    </a>
                  </div>
                )}
              </div>

              {/* Terms & Balance */}
              <div className={styles.paymentCard}>
                <h2 className={styles.cardSectionTitleLight}>
                  Terms & Balance
                </h2>

                {terms.map(([label, key]) => (
                  <div key={key} className={styles.inputGroupLight}>
                    <h3 className={styles.inputLabelLight}>{label}:</h3>

                    <input
                      readOnly
                      className={styles.inputFieldLight}
                      value={
                        key.toLowerCase().endsWith("date")
                          ? fmtDate(aod[key])
                          : display(key)
                      }
                    />
                  </div>
                ))}
              </div>

              {/* Receipts & Totals */}
              <div
                className={`${styles.paymentCard} ${
                  receiptsOK ? styles.successText : styles.errorText
                }`}
              >
                <h2 className={styles.cardSectionTitleLight}>Status</h2>

                {receipts.map(([label, key]) => (
                  <div key={key} className={styles.inputGroupLight}>
                    <h3 className={styles.inputLabelLight}>{label}:</h3>

                    <input
                      readOnly
                      className={styles.inputFieldLight}
                      value={display(key)}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
